import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { AppContext } from '../../context/AppContext';
import { FaCalculator } from '../../components/Icons';
import { SectionHeaderComp } from './LastresLigaPage';
import { FaArrowRight } from 'react-icons/fa';
import { theme } from '../../theme';

const Container = styled.div`
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
`;

const Title = styled.h1`
  font-size: 1.8rem;
  color: ${theme.colors.primary.main};
  margin: 0;
  display: flex;
  align-items: center;
  
  svg {
    margin-right: 10px;
  }
`;

const LigasList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
`;

const LigaCard = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
  }
`;

const LigaTitle = styled.h3`
  color: ${theme.colors.primary.dark};
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 1.2rem;
`;

const LigaDescription = styled.p`
  color: ${theme.colors.text.secondary};
  margin-bottom: 15px;
  font-size: 0.9rem;
  line-height: 1.4;
`;

const LigaCategory = styled.div`
  display: inline-block;
  background-color: ${theme.colors.primary.light};
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 500;
`;

const ViewButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  background-color: ${theme.colors.secondary.main};
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 15px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background-color 0.2s;
  width: 100%;
  
  &:hover {
    background-color: ${theme.colors.secondary.dark};
  }
  
  svg {
    margin-left: 8px;
  }
`;

const EmptyMessage = styled.div`
  text-align: center;
  padding: 40px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  color: ${theme.colors.text.secondary};
  font-size: 1.1rem;
`;

const LastresListPage: React.FC = () => {
  const { data } = useContext(AppContext);
  const navigate = useNavigate();
  
  const handleViewLastres = (ligaId: string) => {
    navigate(`/ligas/${ligaId}/lastres`);
  };
  
  return (
    <Container>
      <SectionHeaderComp icon={<FaCalculator style={{ color: '#e4312e' }} />}>
  Lastres por Liga
</SectionHeaderComp>
      
      {data.ligas.length === 0 ? (
        <EmptyMessage>
          No hay ligas disponibles para mostrar lastres.
        </EmptyMessage>
      ) : (
        <LigasList>
          {data.ligas.map(liga => (
            <LigaCard key={liga.id} onClick={() => handleViewLastres(liga.id)}>
              <LigaTitle>{liga.nombre}</LigaTitle>
              <LigaDescription>
                {liga.descripcion?.substring(0, 100)}
                {liga.descripcion && liga.descripcion.length > 100 ? '...' : ''}
              </LigaDescription>
              <LigaCategory>{liga.categoria || 'Sin categoría'}</LigaCategory>
              <ViewButton onClick={(e) => {
                e.stopPropagation();
                handleViewLastres(liga.id);
              }}>
                Ver Lastres <FaArrowRight />
              </ViewButton>
            </LigaCard>
          ))}
        </LigasList>
      )}
    </Container>
  );
};

export default LastresListPage;
